import { ReactElement } from 'react';

import { BindingCreator } from '@dreryk/react-common';

import { systemActivityTranslationKeys } from '../../../../../../translations';

import { StyledReviewRequestDecisionJustificationTextarea } from './ReviewRequestDecisionJustificationField.styled';

export type ReviewRequestDecisionJustificationFieldFormBeanPart = { decisionJustification: string | null };

const DECISION_JUSTIFICATION_MAX_LENGTH = 500;

type ReviewRequestDecisionJustificationFieldProps = {
   register: BindingCreator<ReviewRequestDecisionJustificationFieldFormBeanPart, 'decisionJustification'>;
};

export const ReviewRequestDecisionJustificationField = (
   props: ReviewRequestDecisionJustificationFieldProps
): ReactElement => {
   return (
      <StyledReviewRequestDecisionJustificationTextarea
         testId={'decisionJustification'}
         controller={props.register('decisionJustification', { maxLength: DECISION_JUSTIFICATION_MAX_LENGTH })}
         label={systemActivityTranslationKeys.reason}
         placeholder={systemActivityTranslationKeys.reasonPlaceholder}
         maxLength={DECISION_JUSTIFICATION_MAX_LENGTH}
         fillParent
      />
   );
};
